var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInteractivecontent = function SvgInteractivecontent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.439 82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47259"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.596,
    cy: 3.596,
    r: 3.596,
    "data-name": "Ellipse 11228",
    transform: "translate(37.404)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.158,
    cy: 2.158,
    r: 2.158,
    "data-name": "Ellipse 11229",
    transform: "translate(12.947 12.947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.404 74.994H61.86V82H37.404z",
    "data-name": "Rectangle 26160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.221 53.855a3 3 0 0 0-.279.334 2.135 2.135 0 0 0 .288 2.7l12.286 12.289a.72.72 0 0 1 .21.508v3.87h15.825V69.93a.7.7 0 0 1 .121-.4l2.749-4.135V49.79a2.158 2.158 0 0 0-4.316 0v4.2a.72.72 0 1 1-1.439 0v-7.077a2.158 2.158 0 0 0-4.316 0v7.193a.72.72 0 1 1-1.439 0v-8.632a2.158 2.158 0 1 0-4.316 0v8.632a.72.72 0 0 1-1.439 0V38.281a2.158 2.158 0 1 0-4.316 0v20.385a.719.719 0 0 1-1.229.509l-5.336-5.323a2.17 2.17 0 0 0-3.057 0Z",
    "data-name": "Path 44903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.755 41.878a3.9 3.9 0 0 1 2.366.886 9.26 9.26 0 0 0 1.23-4.641 9.351 9.351 0 1 0-12.947 8.632v-8.474a3.6 3.6 0 0 1 7.193 0v4.316a3.58 3.58 0 0 1 2.158-.719",
    "data-name": "Path 44904"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.158,
    cy: 2.158,
    r: 2.158,
    "data-name": "Ellipse 11230",
    transform: "translate(64.737 12.947)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.596,
    cy: 3.596,
    r: 3.596,
    "data-name": "Ellipse 11231",
    transform: "translate(0 35.965)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.596,
    cy: 3.596,
    r: 3.596,
    "data-name": "Ellipse 11232",
    transform: "translate(76.246 35.965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.175 41a.72.72 0 0 0-.719-.719H60.3a20 20 0 0 0 .121-2.158 19.3 19.3 0 0 0-3.9-11.625l2.253-2.251a.722.722 0 0 0-1.02-1.022l-2.142 2.144a19.36 19.36 0 0 0-13.893-6.633v-2.192a.72.72 0 0 0-1.439 0v2.194a19.36 19.36 0 0 0-13.893 6.633l-2.141-2.146a.72.72 0 0 0-1.019 1.019l2.253 2.251a19.3 19.3 0 0 0-3.9 11.625 20 20 0 0 0 .121 2.158h-3.719a.72.72 0 0 0 0 1.439h3.95a19.2 19.2 0 0 0 6.338 11.051 3.637 3.637 0 0 1 5.024.065l4.109 4.094v-8.66a10.807 10.807 0 1 1 12.612-4.264c.033.075.079.144.108.222a3.6 3.6 0 0 1 5.982 2.689 3.84 3.84 0 0 1 2.552-.7 19.2 19.2 0 0 0 1.41-4.5h5.389a.72.72 0 0 0 .719-.714",
    "data-name": "Path 44905"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.719,
    cy: 0.719,
    r: 0.719,
    "data-name": "Ellipse 11233",
    transform: "translate(12.947 40.281)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.719,
    cy: 0.719,
    r: 0.719,
    "data-name": "Ellipse 11234",
    transform: "translate(20.14 20.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.719,
    cy: 0.719,
    r: 0.719,
    "data-name": "Ellipse 11235",
    transform: "translate(40.281 11.509)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.719,
    cy: 0.719,
    r: 0.719,
    "data-name": "Ellipse 11236",
    transform: "translate(60.421 20.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.719,
    cy: 0.719,
    r: 0.719,
    "data-name": "Ellipse 11237",
    transform: "translate(69.053 40.281)"
  }))));
};
export default SvgInteractivecontent;